module.exports = __webpack_public_path__ + "static/media/testfile_lr.a5be29cb.zip";